"use strict";
var $ = require("../internals/export");
var uncurryThis = require("../internals/function-uncurry-this");
var aDataView = require("../internals/a-data-view");
var toIndex = require("../internals/to-index");
var log2 = require("../internals/math-log2");
var roundTiesToEven = require("../internals/math-round-ties-to-even");
var pow = Math.pow;
var MIN_INFINITY16 = 65520;
var MIN_NORMAL16 = 61005353927612305e-21;
var REC_MIN_SUBNORMAL16 = 16777216;
var REC_SIGNIFICAND_DENOM16 = 1024;
var packFloat16 = function(value) {
  if (value !== value) return 32256;
  if (value === 0) return (1 / value === -Infinity) << 15;
  var neg = value < 0;
  if (neg) value = -value;
  if (value >= MIN_INFINITY16) return neg << 15 | 31744;
  if (value < MIN_NORMAL16) return neg << 15 | roundTiesToEven(value * REC_MIN_SUBNORMAL16);
  var exponent = log2(value) | 0;
  if (exponent === -15) {
    return neg << 15 | REC_SIGNIFICAND_DENOM16;
  }
  var significand = roundTiesToEven((value * pow(2, -exponent) - 1) * REC_SIGNIFICAND_DENOM16);
  if (significand === REC_SIGNIFICAND_DENOM16) {
    return neg << 15 | exponent + 16 << 10;
  }
  return neg << 15 | exponent + 15 << 10 | significand;
};
var setUint16 = uncurryThis(DataView.prototype.setUint16);
$({ target: "DataView", proto: true }, {
  setFloat16: function setFloat16(byteOffset, value) {
    setUint16(
      aDataView(this),
      toIndex(byteOffset),
      packFloat16(+value),
      arguments.length > 2 ? arguments[2] : false
    );
  }
});
